import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../services/reports.service';

@Component({
  selector: 'app-venues-low-scratch-paper',
  templateUrl: './venues-low-scratch-paper.component.html',
  styleUrls: ['./venues-low-scratch-paper.component.css']
})
export class VenuesLowScratchPaperComponent implements OnInit {

  fetching: boolean = false;
  weeksThreshold: number = 6;

  venuesLowScratchPaper: VenuesLowScratchPaper[] = [];


  constructor(private reportService: ReportsService) { }

  ngOnInit(): void {
    this.fetchVenuesLowScratchPaper();
  }


  fetchVenuesLowScratchPaper() {
    this.fetching = true;
    this.venuesLowScratchPaper = [];
    this.reportService.getVenuesLowScratchPaper(this.weeksThreshold, 4).subscribe({
      next: (res) => {
        this.venuesLowScratchPaper = res;
        this.fetching = false;
      },
      error: (err) => {
        console.error(err);
        this.fetching = false;
      }
    });
  }

  startEdit(index: number) {
    const venue = this.venuesLowScratchPaper[index];
    venue.editing = true;
    venue.editedPaperLeft = venue.paper_left;
  }

  saveEdit(index: number) {
    const venue = this.venuesLowScratchPaper[index];
    if (venue.editedPaperLeft !== undefined && venue.editedPaperLeft >= 0) {
      venue.updating = true;

      this.reportService.updateVenuePaperSupply(venue.kt_venue_id, venue.editedPaperLeft).subscribe({
        next: () => {
          venue.paper_left = venue.editedPaperLeft!;
          venue.updating = false;
          venue.editing = false;
          venue.editedPaperLeft = undefined;
        },
        error: (err) => {
          console.error('Error updating paper left:', err);
          venue.updating = false;
          venue.editing = false;
          venue.editedPaperLeft = undefined;
        }
      });

    }
  }

  cancelEdit(index: number) {
    const venue = this.venuesLowScratchPaper[index];
    venue.editing = false;
    venue.editedPaperLeft = undefined;
  }

}
